import { Client } from '@app/core/types/client';
import { User } from '@mi-front/core';
import { useMemo } from 'react';
import { useImpersonation } from '../hooks/useImpersonationStore';

/**
 * Resolves the tab-scoped deep-link auth_as user from a loaded users list.
 * Returns null when there is no session auth_as or the user is not in the list yet.
 */
export function useTabAuthAsUser(users: Array<User & { client: Client }>) {
  const { tabAuthAsUserId: tabAuthAsId } = useImpersonation();

  return useMemo(() => {
    if (!tabAuthAsId) {
      return null;
    }
    return users.find((user) => user.id === tabAuthAsId) ?? null;
  }, [tabAuthAsId, users]);
}
